export default "__VITE_ASSET__Bxw3K9Yp__"